import { VStack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";
import { CustomCheckbox } from "@lubbezposrednio-frontend/commons";
import { AuthorizationModel, bindProperty } from "@lubbezposrednio-frontend/core";

interface CheckboxesSectionProps {
  authorization: AuthorizationModel;
}

export const CheckboxesSection: React.FC<CheckboxesSectionProps> = observer(({ authorization }) => {
  return (
    <VStack align="stretch" w="100%" spacing="10px" mt="4px">
      <CustomCheckbox
        required
        label="Zapoznałem się z Regulaminem i Polityką Prywatności"
        {...bindProperty(authorization, "applicationServiceTerms")}
      />
      <CustomCheckbox
        label="Wyrażam zgodę na otrzymywanie materiałów informacyjnych i marketingowych w związku z działalnością platformy lubbezposrednio.pl i realizacją zadania Instytut Demokracji Bezpośredniej"
        {...bindProperty(authorization, "applicationMarketingTerms")}
      />
    </VStack>
  );
});
